export const common = {
  nav: {
    searchJobs: 'Buscar Empleos',
    forEmployers: 'Para Empleadores',
    resources: 'Recursos',
    postJob: 'Publicar Vacante',
    login: 'Iniciar Sesi\u00f3n',
    register: 'Registrarse',
    employerPanel: 'Panel Empleador',
    candidatePanel: 'Panel Candidato',
    adminPanel: 'Panel Admin',
    logout: 'Cerrar Sesi\u00f3n',
    home: 'Inicio',
    forCompanies: 'Para Empresas',
    myPanel: 'Mi Panel',
  },
  hero: {
    badge: '\uD83D\uDD25 +2,500 empleos activos en NYC',
    title: 'Conectando Talento Hispano con Oportunidades en NYC',
    subtitle: 'Plataforma inteligente con filtros avanzados y notificaciones en tiempo real para profesionales y empleadores',
    searchJobsBtn: 'Buscar Empleos',
    employerBtn: 'Soy Empleador',
  },
  search: {
    placeholder: 'T\u00edtulo del trabajo, palabras clave...',
    location: 'Todos los boroughs de NYC',
    category: 'Todas las industrias',
    searchBtn: 'Buscar',
    jobsFound: 'empleos encontrados',
    advancedFilters: 'Filtros avanzados',
    filters: {
      jobType: 'Tipo de empleo',
      fullTime: 'Tiempo completo',
      partTime: 'Medio tiempo',
      freelance: 'Freelance',
      remote: 'Remoto',
      salaryRange: 'Rango salarial',
      experience: 'Nivel de experiencia',
      entry: 'Principiante',
      mid: 'Intermedio',
      senior: 'Senior',
      executive: 'Ejecutivo',
      benefits: 'Beneficios',
      healthInsurance: 'Seguro m\u00e9dico',
      retirement: '401k',
      visaSponsorship: 'Patrocinio de visa',
    },
  },
  stats: {
    label: 'IMPACTO EN N\u00daMEROS',
    intro: 'EmpleosNYC es la plataforma l\u00edder que conecta profesionales talentosos con empleadores de Nueva York. Nuestro compromiso es facilitar oportunidades laborales para la comunidad hispana y todos los profesionales que buscan crecer en la ciudad que nunca duerme.',
    activeJobs: 'empleos activos',
    activeJobsDesc: 'Vacantes verificadas diariamente',
    professionals: 'profesionales registrados',
    professionalsDesc: 'Usuarios activos buscando empleo',
    satisfaction: 'tasa de satisfacci\u00f3n',
    satisfactionDesc: 'Usuarios satisfechos con nuestro servicio',
    companies: 'empresas',
    companiesDesc: 'Empleadores confiando en nuestra plataforma',
  },
  testimonials: {
    badge: '\u2B50 Historias de \u00c9xito',
    title: 'Lo que dicen nuestros usuarios sobre EmpleosNYC',
  },
  cta: {
    title: '\u00bfBuscas talento para tu empresa?',
    subtitle: 'Publica vacantes y conecta con los mejores profesionales de Nueva York',
    benefits: {
      dashboard: 'Panel de control intuitivo',
      realtime: 'Gesti\u00f3n de candidatos en tiempo real',
      notifications: 'Notificaciones instant\u00e1neas',
      support: 'Soporte prioritario en espa\u00f1ol',
    },
    button: 'Comenzar Ahora',
    note: 'Reg\u00edstrate gratis y publica tu primera vacante',
  },
  features: {
    sectionTitle: 'Plataforma completa',
    sectionTitleHighlight: 'para gestionar',
    sectionSubtitle: 'todo tu proceso de contrataci\u00f3n',
    employerPanel: 'Panel Empleador',
    employerPanelDesc: 'Gestiona todas tus vacantes, candidatos y conversaciones desde un solo lugar',
    realTimeAlerts: 'Alertas en Tiempo Real',
    realTimeAlertsDesc: 'Recibe notificaciones instant\u00e1neas cuando un candidato aplica o un empleador responde',
    messaging: 'Mensajer\u00eda Integrada',
    messagingDesc: 'Comun\u00edcate directamente con empleadores o candidatos sin salir de la plataforma',
  },
  jobs: {
    new: 'Nuevo',
    viewDetails: 'Ver Detalles',
    loadingJobs: 'Cargando empleos...',
    noJobs: 'No hay empleos disponibles',
    noJobsDesc: 'Pronto habr\u00e1 nuevas oportunidades laborales',
    viewMore: 'Ver m\u00e1s empleos',
    salaryNegotiable: 'Salario a convenir',
    salaryFrom: 'Desde',
    salaryTo: 'Hasta',
    views: 'vistas',
    applications: 'aplicaciones',
    apply: 'Aplicar',
    alreadyApplied: 'Ya Aplicaste',
    fullTime: 'Tiempo Completo',
    partTime: 'Medio Tiempo',
    contract: 'Contrato',
    freelance: 'Freelance',
    internship: 'Pasant\u00eda',
    requirements: 'Requisitos',
    benefits: 'Beneficios',
    description: 'Descripci\u00f3n del Puesto',
    aboutCompany: 'Sobre la Empresa',
    jobDetails: 'Detalles del Empleo',
    salary: 'Salario',
    location: 'Ubicaci\u00f3n',
    type: 'Tipo',
    category: 'Categor\u00eda',
    postedOn: 'Publicado el',
    applyNow: 'Aplicar Ahora',
    loginToApply: 'Inicia sesi\u00f3n para aplicar',
    registerToApply: 'Reg\u00edstrate para aplicar',
    backToJobs: 'Volver a empleos',
    shareJob: 'Compartir empleo',
    similarJobs: 'Empleos Similares',
  },
  footer: {
    tagline: 'Tu puente al empleo en NYC',
    newsletter: 'Suscr\u00edbete a nuestro bolet\u00edn',
    newsletterSuccess: '\u00a1Gracias por suscribirte!',
    newsletterError: 'Error al suscribirse. Int\u00e9ntalo de nuevo.',
    forProfessionals: 'Para Profesionales',
    searchJobs: 'Buscar Empleos',
    createProfile: 'Crear Perfil',
    careerResources: 'Recursos de Carrera',
    forEmployers: 'Para Empleadores',
    postJob: 'Publicar Vacante',
    pricing: 'Planes y Precios',
    helpCenter: 'Centro de Ayuda',
    company: 'Compa\u00f1\u00eda',
    about: 'Sobre Nosotros',
    blog: 'Blog',
    contact: 'Contacto',
    legal: 'Legal',
    terms: 'T\u00e9rminos de Uso',
    privacy: 'Privacidad',
    cookies: 'Cookies',
    copyright: '\u00a9 2026 EmpleosNYC. Todos los derechos reservados.',
    visitors: 'Visitantes',
    madeWith: 'Hecho con \u2764\uFE0F en NYC',
    quickLink: 'Website Builder',
  },
  dashboard: {
    panel: 'Panel',
    myJobs: 'Mis Empleos',
    applications: 'Aplicaciones',
    messages: 'Mensajes',
    searchJobs: 'Buscar Empleos',
    myApplications: 'Mis Aplicaciones',
    overview: 'Panel General',
    users: 'Usuarios',
    jobs: 'Empleos',
    subscriptions: 'Suscripciones',
    reports: 'Reportes',
    campaigns: 'Campa\u00f1as',
    help: 'Ayuda',
    myProfile: 'Mi Perfil',
    settings: 'Configuraci\u00f3n',
    contactAdmin: 'Contactar Admin',
    signOut: 'Cerrar Sesi\u00f3n',
    language: 'Idioma',
    employer: 'Empleador',
    candidate: 'Candidato',
    administrator: 'Administrador',
    employerPanel: 'Panel de Empleador',
    manageJobs: 'Gestiona tus ofertas de trabajo y aplicaciones',
    postJob: 'Publicar Empleo',
    totalJobs: 'Total Empleos',
    activeJobs: 'Empleos Activos',
    totalApplications: 'Aplicaciones',
    totalViews: 'Vistas Totales',
    newApps: 'nueva',
    stats: 'Estad\u00edsticas',
    payments: 'Pagos',
    billing: 'Facturaci\u00f3n',
    goodMorning: 'Buenos d\u00edas',
    goodAfternoon: 'Buenas tardes',
    goodEvening: 'Buenas noches',
    findNextJob: 'Encuentra tu pr\u00f3xima oportunidad laboral en Nueva York',
    checkApplications: 'Revisa el estado de tus aplicaciones',
    noJobsFound: 'No se encontraron empleos',
    adjustFilters: 'Intenta ajustar tus filtros de b\u00fasqueda o explora otras categor\u00edas.',
    clearFilters: 'Limpiar Filtros',
    searchingJobs: 'Buscando empleos...',
    jobsFound: 'empleos encontrados',
    newMessage: 'Nuevo Mensaje',
    communicateWith: 'Comun\u00edcate directamente con',
    employers: 'empleadores',
    candidates: 'candidatos',
    publish: 'Publicar',
    loading: 'Cargando...',
    // Candidate specific
    candidateGreeting: '\u00a1Hola',
    jobsTab: 'Empleos',
    applicationsTab: 'Aplicaciones',
    myProfileBtn: 'Mi Perfil',
    availableJobs: 'Empleos Disponibles',
    myApplicationsCount: 'Mis Aplicaciones',
    inReview: 'En Revisi\u00f3n',
    hires: 'Contrataciones',
    // Search filters
    searchByTitle: 'Buscar por t\u00edtulo, empresa o palabra clave...',
    cityOrZone: 'Ciudad, estado o zona...',
    jobType: 'Tipo de Empleo',
    categoryLabel: 'Categor\u00eda',
    advancedFilters: 'Filtros Avanzados',
    clearAll: 'Limpiar todo',
    salaryRange: 'Rango Salarial',
    any: 'Cualquiera',
    contractType: 'Tipo de Contrato',
    modality: 'Modalidad',
    onSite: 'Presencial',
    remote: 'Remoto',
    hybrid: 'H\u00edbrido',
    experience: 'Experiencia',
    noExperience: 'Sin experiencia',
    junior: 'Junior',
    intermediate: 'Intermedio',
    senior: 'Senior',
    leadManager: 'Lead / Manager',
    datePosted: 'Fecha de Publicaci\u00f3n',
    anyDate: 'Cualquier fecha',
    last24h: '\u00daltimas 24 horas',
    last3d: '\u00daltimos 3 d\u00edas',
    lastWeek: '\u00daltima semana',
    last14d: '\u00daltimos 14 d\u00edas',
    lastMonth: '\u00daltimo mes',
    urgentOnly: 'Solo Urgentes',
    requiredSkills: 'Habilidades Requeridas',
    searchSkill: 'Buscar habilidad...',
    sortRecent: 'M\u00e1s recientes',
    sortSalaryHigh: 'Mayor salario',
    sortSalaryLow: 'Menor salario',
    sortMostApplied: 'M\u00e1s aplicados',
    jobFound: 'empleo encontrado',
    jobsFoundPlural: 'empleos encontrados',
    fullTime: 'Tiempo Completo',
    partTime: 'Medio Tiempo',
    contract: 'Contrato',
    freelance: 'Freelance',
    internship: 'Pasant\u00eda',
    // Job card
    today: 'Hoy',
    yesterday: 'Ayer',
    daysAgo: 'Hace {{count}} d\u00edas',
    weeksAgo: 'Hace {{count}} sem.',
    monthsAgo: 'Hace {{count}} mes',
    monthsAgoPlural: 'Hace {{count}} meses',
    urgent: 'Urgente',
    negotiable: 'A convenir',
    from: 'Desde',
    upTo: 'Hasta',
    applied: 'Aplicado',
    apply: 'Aplicar',
    applyNow: 'Aplicar Ahora',
    more: 'm\u00e1s',
    // Applications - Candidate
    all: 'Todas',
    pending: 'Pendiente',
    viewed: 'Vista',
    reviewed: 'En Revisi\u00f3n',
    inProgress: 'En Proceso',
    hired: 'Contratado',
    accepted: 'Aceptada',
    rejected: 'Rechazada',
    withdrawn: 'Retirada',
    incomplete: 'Incompleta',
    noApplicationsYet: 'Sin aplicaciones a\u00fan',
    exploreJobs: 'Explora los empleos disponibles y aplica a las oportunidades que te interesen.',
    noApplicationsFilter: 'No hay aplicaciones con este estado.',
    viewDetail: 'Ver Detalle',
    goToPosting: 'Ir a Publicaci\u00f3n',
    withdraw: 'Retirar',
    withdrawApplication: 'Retirar Aplicaci\u00f3n',
    withdrawReason: 'Indica el motivo por el cual deseas retirar tu aplicaci\u00f3n. Esta informaci\u00f3n ser\u00e1 visible para el empleador.',
    withdrawPlaceholder: 'Ej: He aceptado otra oferta, No cumple con mis expectativas salariales, etc.',
    cancel: 'Cancelar',
    confirmWithdraw: 'Confirmar Retiro',
    withdrawing: 'Retirando...',
    withdrawalReason: 'Motivo del retiro',
    appliedOn: 'Aplicado',
    viewedByEmployer: 'Visto por empleador',
    salary: 'Salario',
    type: 'Tipo',
    category: 'Categor\u00eda',
    status: 'Estado',
    active: 'Activo',
    closed: 'Cerrado',
    jobDescription: 'Descripci\u00f3n del Puesto',
    requirements: 'Requisitos',
    benefits: 'Beneficios',
    contact: 'Contacto',
    viewFullPosting: 'Ver Publicaci\u00f3n Completa',
    close: 'Cerrar',
    loadingApplications: 'Cargando aplicaciones...',
    // Applications - Employer
    activeApps: 'Activas',
    newAppsLabel: 'Nuevas',
    pendingApps: 'Pendientes',
    inProgressApps: 'En Proceso',
    hiredApps: 'Contratados',
    rejectedApps: 'Rechazadas',
    withdrawnApps: 'Retiradas',
    noApplications: 'No hay aplicaciones',
    noApplicationsDesc: 'Cuando los candidatos apliquen a tus empleos, aparecer\u00e1n aqu\u00ed con toda su informaci\u00f3n profesional.',
    newBadge: 'Nueva',
    match: 'Match',
    experiences: 'experiencia',
    experiencesPlural: 'experiencias',
    yearsExp: 'a\u00f1os exp.',
    authorizedUSA: 'Autorizado USA',
    moreSkills: 'm\u00e1s',
    appliedOnDate: 'Aplic\u00f3 el',
    viewedOnDate: 'Vista el',
    viewFullProfile: 'Ver Perfil Completo',
    sendMessage: 'Enviar Mensaje',
    markAsViewed: 'Marcar como Vista',
    downloadCV: 'Descargar CV',
    contactCandidate: 'Contactar',
    changeStatus: 'Cambiar Estado',
    noResults: 'Sin resultados',
    noResultsDesc: 'No hay aplicaciones con el filtro seleccionado.',
    viewAllApplications: 'Ver todas las aplicaciones',
    hiredConfirmation: '\u00a1Contrataci\u00f3n Confirmada!',
    hiredNotificationSent: 'Se enviaron notificaciones por email a',
    andAdmin: 'y al administrador.',
    // Employer tabs
    myJobsTab: 'Mis Empleos',
    applicationsTab2: 'Aplicaciones',
    statsTab: 'Estad\u00edsticas',
    paymentsTab: 'Pagos',
    billingTab: 'Facturaci\u00f3n',
    // Jobs list
    noJobsPublished: 'No hay empleos publicados',
    startPublishing: 'Comienza publicando tu primera oferta de trabajo',
    title: 'T\u00edtulo',
    location: 'Ubicaci\u00f3n',
    statusCol: 'Estado',
    applicationsCol: 'Aplicaciones',
    viewsCol: 'Vistas',
    actions: 'Acciones',
    edit: 'Editar',
    pause: 'Pausar',
    activate: 'Activar',
    delete: 'Eliminar',
    editJob: 'Editar Empleo',
    description: 'Descripci\u00f3n',
    minSalary: 'Salario M\u00ednimo',
    maxSalary: 'Salario M\u00e1ximo',
    applicationEmail: 'Correo para Aplicaciones',
    saveChanges: 'Guardar Cambios',
    jobUpdated: 'Empleo actualizado exitosamente',
    inReviewStatus: 'En Revisi\u00f3n',
    rejectedStatus: 'Rechazado',
    inactive: 'Inactivo',
    free: 'GRATIS',
    // Subscription banner
    publishFirstJob: 'Publica tu Primer Empleo',
    payPerUse: 'Paga solo por lo que necesitas',
    pricePerJob: '$5 por cada publicaci\u00f3n de empleo',
    noSubscriptions: 'Sin suscripciones mensuales',
    unlimitedCandidates: 'Gestiona candidatos ilimitados',
    fullAccess: 'Acceso completo a todas las funciones',
    howItWorks: '\u00bfC\u00f3mo funciona?',
    howItWorksDesc: 'Cada vez que publiques un empleo, se te cobrar\u00e1 $5. El empleo permanecer\u00e1 activo hasta que lo cierres o encuentres al candidato ideal. Sin compromisos mensuales.',
    publishNow: 'Publicar Ahora',
    // Stats
    totalViewsStat: 'Vistas Totales',
    applicationsStat: 'Aplicaciones',
    conversionRate: 'Tasa de Conversi\u00f3n',
    activeJobsStat: 'Empleos Activos',
    total: 'Total',
    average: 'Promedio',
    performanceByJob: 'Rendimiento por Empleo',
    analyzePerformance: 'Analiza el desempe\u00f1o de cada publicaci\u00f3n',
    days7: '7 d\u00edas',
    days30: '30 d\u00edas',
    allTime: 'Todo',
    noData: 'Sin datos',
    publishFirst: 'Publica tu primer empleo para ver estad\u00edsticas',
    job: 'Empleo',
    views: 'Vistas',
    conversion: 'Conversi\u00f3n',
    performance: 'Rendimiento',
    excellent: 'Excelente',
    good: 'Bueno',
    normal: 'Normal',
    low: 'Bajo',
    ofTotal: 'del total',
    aboveAvg: 'Por encima',
    belowAvg: 'Por debajo',
    ofAverage: 'del promedio',
    tipsToImprove: 'Consejos para mejorar',
    tipTitle: 'Mejora el t\u00edtulo del empleo para que sea m\u00e1s atractivo',
    tipShare: 'Comparte la oferta en redes sociales para aumentar visibilidad',
    tipRequirements: 'Revisa los requisitos, podr\u00edan ser muy restrictivos',
    tipRespond: 'Responde r\u00e1pido a los candidatos para mantener su inter\u00e9s',
    // Billing
    totalSpending: 'Gasto Total',
    fullHistory: 'Hist\u00f3rico completo',
    thisMonth: 'Este Mes',
    monthlyAvg: 'Promedio Mensual',
    months: 'meses',
    totalPublications: 'Total Publicaciones',
    paid: 'pagadas',
    freeLabel: 'gratis',
    monthlySpending: 'Gasto Mensual',
    monthlyStatements: 'Estados de Cuenta Mensuales',
    noTransactions: 'Sin transacciones',
    noTransactionsDesc: 'Cuando publiques empleos, tus estados de cuenta mensuales aparecer\u00e1n aqu\u00ed.',
    transactions: 'transacciones',
    transaction: 'transacci\u00f3n',
    printStatement: 'Imprimir Estado',
    date: 'Fecha',
    concept: 'Concepto',
    method: 'M\u00e9todo',
    amount: 'Monto',
    monthTotal: 'Total del Mes',
    jobPosting: 'Publicaci\u00f3n de empleo',
    // Payments
    totalSpent: 'Total Gastado',
    paidPublications: 'Publicaciones Pagadas',
    each: 'c/u',
    freePublications: 'Publicaciones Gratis',
    couponOrFirst: 'Cup\u00f3n o primer empleo',
    allFilter: 'Todos',
    paidFilter: 'Pagados',
    freeFilter: 'Gratis',
    search: 'Buscar...',
    export: 'Exportar',
    noTransactionsFilter: 'Sin resultados',
    noTransactionsFilterDesc: 'No hay transacciones con este filtro.',
    receipt: 'Recibo',
    sent: 'Enviado',
    printReceipt: 'Imprimir Recibo',
    generating: 'Generando...',
    sendReceipt: 'Enviar Recibo',
    resendReceipt: 'Reenviar Recibo',
    sending: 'Enviando...',
    copyTransactionId: 'Copiar ID Transacci\u00f3n',
    transactionIdCopied: 'ID de transacci\u00f3n copiado',
    receiptSentEmail: 'Recibo enviado a tu correo electr\u00f3nico',
    noActionsAvailable: 'Sin acciones disponibles',
    completed: 'Completado',
    pendingStatus: 'Pendiente',
    failed: 'Fallido',
    refunded: 'Reembolsado',
    loadingPayments: 'Cargando historial de pagos...',
    loadingBilling: 'Cargando facturaci\u00f3n...',
    // Candidate profile modal
    loadingProfile: 'Cargando perfil del candidato...',
    candidateNotFound: 'Candidato no encontrado',
    candidateNotFoundDesc: 'No se pudo cargar la informaci\u00f3n del candidato.',
    summary: 'Resumen',
    experienceTab: 'Experiencia',
    educationTab: 'Educaci\u00f3n',
    applicationTab: 'Aplicaci\u00f3n',
    contactInfo: 'Informaci\u00f3n de Contacto',
    email: 'Email',
    phone: 'Tel\u00e9fono',
    locationLabel: 'Ubicaci\u00f3n',
    viewProfile: 'Ver Perfil',
    skills: 'Habilidades',
    skillsMatchNote: 'Las habilidades resaltadas coinciden con los requisitos del puesto',
    aboutCandidate: 'Sobre el Candidato',
    languages: 'Idiomas',
    quickSummary: 'Resumen R\u00e1pido',
    experiencesCount: 'Experiencias',
    educationCount: 'Educaci\u00f3n',
    certificationsCount: 'Certificaciones',
    skillsCount: 'Habilidades',
    availability: 'Disponibilidad',
    canStart: 'Puede comenzar',
    salaryExpectation: 'Expectativa salarial',
    willingToRelocate: 'Dispuesto a reubicarse',
    authorizedToWorkUSA: 'Autorizado para trabajar en USA',
    educationLevel: 'Nivel Educativo',
    viewLinkedIn: 'Ver LinkedIn',
    viewPortfolio: 'Ver Portafolio',
    noExperienceRegistered: 'Sin experiencia registrada',
    noExperienceDesc: 'El candidato no ha agregado experiencia laboral.',
    currentJob: 'Trabajo Actual',
    present: 'Presente',
    highestEducation: 'Nivel Educativo M\u00e1s Alto',
    noEducationDetail: 'Sin historial educativo detallado',
    noEducationDesc: 'El candidato no ha agregado detalles de su educaci\u00f3n.',
    certifications: 'Certificaciones',
    obtained: 'Obtenido',
    expires: 'Expira',
    noExpiration: 'No expira',
    applicationDetails: 'Detalles de la Aplicaci\u00f3n',
    position: 'Puesto',
    applicationDate: 'Fecha de Aplicaci\u00f3n',
    matchScore: 'Match Score',
    coverLetter: 'Carta de Presentaci\u00f3n',
    additionalInfo: 'Informaci\u00f3n Adicional',
    availabilityLabel: 'Disponibilidad',
    relocation: 'Reubicaci\u00f3n',
    yesWilling: 'S\u00ed, dispuesto',
    no: 'No',
    yes: 'S\u00ed',
    memberSince: 'Miembro desde',
    excellentMatch: 'Excelente Match',
    goodMatch: 'Buen Match',
    moderateMatch: 'Match Moderado',
    lowMatch: 'Match Bajo',
    // Availability labels
    immediately: 'Inmediatamente',
    oneWeek: 'En 1 semana',
    twoWeeks: 'En 2 semanas',
    oneMonth: 'En 1 mes',
    negotiableAvail: 'Negociable',
    // Education labels
    lessThanHighSchool: 'Sin diploma de secundaria',
    highSchool: 'High School Diploma / GED',
    someCollege: 'Algunos estudios universitarios',
    associate: 'Associate Degree',
    bachelor: "Bachelor's Degree",
    master: "Master's Degree",
    doctorate: 'Doctorado (PhD)',
    professional: 'T\u00edtulo Profesional',
    tradeCertificate: 'Certificado T\u00e9cnico',
    // Language levels
    basic: 'B\u00e1sico',
    intermediateLevel: 'Intermedio',
    advanced: 'Avanzado',
    fluent: 'Fluido',
    native: 'Nativo',
    // Application detail modal
    applicationInfo: 'Informaci\u00f3n de la Aplicaci\u00f3n',
    candidateInfo: 'Informaci\u00f3n del Candidato',
    workExperience: 'Experiencia Laboral',
    educationHistory: 'Historial Educativo',
    timeline: 'L\u00ednea de Tiempo',
    statusHistory: 'Historial de Estado',
    messageEmployer: 'Enviar Mensaje al Empleador',
    messageCandidate: 'Enviar Mensaje al Candidato',
    // Jobs list table
    companyName: 'Empresa',
    freeTag: 'GRATIS',
    couponUsed: 'Cupón usado',
    editTitle: 'Editar',
    pauseTitle: 'Pausar',
    activateTitle: 'Activar',
    deleteTitle: 'Eliminar',
    deleteConfirm: '¿Estás seguro de eliminar este empleo?',
    deletePaidWarning: '⚠️ IMPORTANTE: Este empleo ya fue pagado ($5). Al eliminarlo NO se realizará ningún reembolso. Los pagos son finales una vez publicado el empleo.',
    deletePaidConfirm: '¿Estás seguro de eliminar este empleo? NO habrá reembolso.',
    deleteError: 'Error al eliminar el empleo',
    updateError: 'Error al actualizar el empleo',
  },
};
